__webpack_require__.p = "//qa-a-static.zhihuiya.com/a-patent-view/26.2.4/";